import { NONE, PROFILE_OPTION_SELECT, REGION, ROLE, SEGMENT } from '../constants';
import { filter, includes } from 'lodash';

const selections = [ SEGMENT, ROLE, REGION ];

export interface ProfileReducerState {
    segment: string;
    role: string;
    region: string;
    isValid: boolean;
}

interface Payload {
    option: string;
    id: string;
}

interface Action {
    type: string;
    payload: Payload;
}

const initialState = {
    segment: NONE,
    role: NONE,
    region: NONE,
    isValid: false
};

function getSelectionsThatNeedValidation (state: ProfileReducerState) {
    return filter(state, (item, key): boolean => includes(selections, key));
}

function allSelectionsValid(state: ProfileReducerState): boolean {
    const selectionsToValidate = getSelectionsThatNeedValidation(state);
    const valid = filter(selectionsToValidate, (item) => item === NONE);

    return valid.length < 1;
}

function upateOptionState(state: ProfileReducerState, payload: Payload) {
    state[payload.id] = payload.option;

    const isValid = allSelectionsValid(state);

    return {
        ...state,
        isValid
    };
}

const profileReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case PROFILE_OPTION_SELECT:
            const newState = upateOptionState(state, action.payload);

            return {
                ...state,
                ...newState
            };
        default:
            return {
                ...state
            };
    }
};

export default profileReducer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/reducers/profileReducer.ts